import { useState } from "react";
import { Button } from "../ui/button";
import { toaster } from "../ui/toaster";
import { BiTrash } from "react-icons/bi";
import { useWebHelper } from "@viabl/echo-web-client-core";
import { Dialog, Text, useDisclosure, Portal, CloseButton, DialogActionTrigger, DialogBody, DialogCloseTrigger, DialogFooter, DialogPositioner, Input } from '@chakra-ui/react';
import { IBundle } from "../../pages/echoRoleBundles";
import { DialogBackdrop, DialogContent, DialogHeader, DialogRoot, DialogTitle, DialogTrigger } from "../ui/dialog";
import { IRole } from "../../pages/echoRoles";

interface newUserProps {
    cb: Function,
    existingRole: IRole,
}

export default function RoleDelete(props: newUserProps) {
    const { onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState<boolean>(false);
    const [input, setInput] = useState<string>("");
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const webHelpers = useWebHelper();

    const handleClickOpen = () => {
        onOpen();
        setOpen(true);
        setInput("")
        setErrors({})
    }

    const handleClick = () => {
        if (input != props.existingRole.role){
            toaster.create({
                title: `Incorrect Role Entered`,
                type: "error",
            })
            return
        }
        webHelpers.DeleteNoResultAsync("/api/role/" + props.existingRole.id, "auth").then(() => {
            handleClose()
            props.cb()

            toaster.create({
                title: `Deleted Role`,
                type: "success",
            })
        })
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <>
            <DialogRoot
                open={open}
                aria-describedby="alert-dialog-slide-description"
                size={{ base: "md", "2xl": "sm" }}
            >
                <Dialog.Backdrop />
                <DialogTrigger>
                    <Button bg={"AbleBlue"} color={"white"} _hover={{ bg: "AbleYellow", color: "white" }} size={"sm"} onClick={handleClickOpen}><BiTrash size={"10px"} />Delete</Button>
                </DialogTrigger>
                <DialogContent marginTop={"0px"} marginBottom={"0px"}>
                    <DialogTitle>Delete Role</DialogTitle>
                    <DialogBody padding={"10px"}>
                        <Text py={5}>Are you sure you want to delete this role?</Text>
                        <Text pb={4}>Please enter the name of the role to delete: </Text>
                        <Input placeholder="Role (Case Senstive)" value={input} onChange={(e) => setInput(e.currentTarget.value)}></Input>
                    </DialogBody>
                    <DialogFooter>
                        <Button onClick={handleClick}
                            disabled={false}
                            bg={"AbleBlue"}
                            color={"white"}
                            _hover={{ color: "AbleYellow" }}>Delete</Button>
                        <DialogTrigger>
                            <Button onClick={handleClose} colorScheme="red" marginLeft={"10px"}>Cancel</Button>
                        </DialogTrigger>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </>
    );
}